import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SectionCard from "./SectionCard";
import { LearningPathway } from "../../compilers/learningPathway";
import { LocalisedLearningPathway } from "../../compilers/LocalisedLearningPathway";
import { getLearningPathways } from "../../api/learningPathways";
import LearningPathwayContainerSkeleton from "./LearningPathwayContainerSkeleton";

const LearningPathwayContainer: React.FC = () => {
  const { i18n } = useTranslation();
  const [learningPathways, setLearningPathways] = useState<LearningPathway[]>(
    []
  );

  useEffect(() => {
    getLearningPathways().then((response: LearningPathway[]) => {
      setLearningPathways(response);
    });
  });

  if (learningPathways && learningPathways.length < 1) {
    return <LearningPathwayContainerSkeleton />;
  }

  const getLocalisedLearningPathways = () => {
    const localised_learning_pathways: LocalisedLearningPathway[] = [];
    if (learningPathways.length > 0) {
      learningPathways.forEach((item) => {
        item.data.localised_data.forEach((localised_lp) => {
          if (localised_lp.language === i18n.language) {
            localised_learning_pathways.push(localised_lp);
          }
        });
      });
    }
    return localised_learning_pathways;
  };

  return (
    <div className="d-grid mt-4">
      <div className="section-card-container learningPathways">
        {getLocalisedLearningPathways().map((pathway) => {
          const card = {
            title: pathway.title,
            body: pathway.description,
            link: `academy/catalogue?f=${pathway.title}`,
          };
          return (
            <SectionCard
              lang={i18n.language}
              key={pathway.title}
              card={card}
              smallTitle={true}
            />
          );
        })}
      </div>
    </div>
  );
};

export default LearningPathwayContainer;
